import { createSlice } from '@reduxjs/toolkit';
import { createExam, getListExams } from './examThunk';
import { RootState } from '~/utils/redux/store';
import { IExam } from '~/utils/interface/exam';
import { DEFAULT_PAGE } from '~/utils/constants/common';

interface ExamState {
  exams: IExam[];
  isRefreshListExam: boolean;
  isLoadingCreateExam: boolean;
  currentPage: number;
  hasMore: boolean;
  isLoading: boolean;
}

const initialState: ExamState = {
  exams: [],
  isLoadingCreateExam: false,
  isRefreshListExam: false,
  currentPage: DEFAULT_PAGE,
  hasMore: false,
  isLoading: false,
};

const examSlice = createSlice({
  name: 'examSlice',
  initialState,
  reducers: {
    setRefreshList(state, action) {
      state.exams = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListExams.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getListExams.fulfilled, (state, action) => {
        state.exams = action.payload.responses;
        state.isLoading = false;
        state.hasMore = action.payload.pagination.page < action.payload.pagination.totalPages;
        state.currentPage = action.payload.pagination.page;
      })
      .addCase(getListExams.rejected, (state) => {
        state.isLoading = false;
      });

    // create exam
    builder
      .addCase(createExam.pending, (state) => {
        state.isLoadingCreateExam = true;
      })
      .addCase(createExam.fulfilled, (state, action) => {
        state.isRefreshListExam = true;
        state.isLoadingCreateExam = false;
      })
      .addCase(createExam.rejected, (state) => {
        state.isLoadingCreateExam = false;
      });
  },
});

// Action
export const examAction = examSlice.actions;

// Selectors
export const selectExams = (state: RootState) => state.examState.exams;

// Reducer
const examReducer = examSlice.reducer;
export default examReducer;
